export default __webpack_public_path__ + "static/media/cactushug.c113cd01.png";